import Keycloak from 'keycloak-js'
import { KeycloakActionType, MenuLinks } from '../../constants'

export interface KeycloakActionConfig {
  action: KeycloakActionType
  loginHint?: string
  idpHint?: string
  keycloak: Keycloak
  redirectPath?: string | MenuLinks
}

export default async function keycloakActions({
  loginHint = '',
  idpHint = '',
  action,
  keycloak,
  redirectPath,
}: KeycloakActionConfig) {
  const redirectUri = `${process.env.REACT_APP_CLIENT_ADDRESS}${redirectPath ? redirectPath : '/'}`

  if (action === KeycloakActionType.SIGNIN) {
    window.history.pushState({}, '', process.env.REACT_APP_CLIENT_ADDRESS)
    keycloak.login({
      idpHint,
      // Login hint is to prefill username password field and is passed to IDP
      loginHint,
      redirectUri,
    })
  }

  if (action === KeycloakActionType.LOGOUT) {
    keycloak.logout({ redirectUri })
  }

  if (action === KeycloakActionType.REGISTER) {
    // TODO How do represent authenticated users in Wells?
    keycloak.register({ redirectUri })
  }
}
